// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { RefObject, useEffect, useState } from 'react';

export function useHover(
  ref: RefObject<HTMLElement>,
  onMouseEnter?: (e: MouseEvent) => void,
  onMouseLeave?: (e: MouseEvent) => void
) {
  const [value, setValue] = useState<boolean>(false);
  const handleMouseEnter = (e: MouseEvent) => {
    setValue(true);
    onMouseEnter?.(e);
  };
  const handleMouseLeave = (e: MouseEvent) => {
    setValue(false);
    onMouseLeave?.(e);
  };

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseenter', handleMouseEnter);
      node.addEventListener('mouseleave', handleMouseLeave);

      return () => {
        node.removeEventListener('mouseenter', handleMouseEnter);
        node.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [ref.current]);

  return value;
}

export default useHover;
